import MESSAGES from "../../constant/messages"
import { e入力パターン, T入力パターン } from "../../constant/validateConstant"
import { stringFormat } from "./commonUtil"

/**
 * string系のエラーメッセージ群
 * @param title エラー対象の項目名
 * @param props エラー表示時の各数値
 * @returns
 */
export const stringErrorMessage = (
  title: string,
  props?: {
    minLength?: number
    maxLength?: number
    required?: boolean
    pattern?: T入力パターン
  }
) => {
  // パターンのメッセージを管理する
  let patternMessage = ""
  if (props?.pattern === e入力パターン.数字のみ) {
    patternMessage = MESSAGES.WARNS.W007
  } else if (props?.pattern === e入力パターン.アルファベットのみ) {
    patternMessage = MESSAGES.WARNS.W008
  } else if (props?.pattern === e入力パターン.英数字のみ) {
    patternMessage = MESSAGES.WARNS.W009
  } else {
    patternMessage = MESSAGES.WARNS.W005
  }

  return {
    required: stringFormat(MESSAGES.WARNS.W001, title),
    // 必須チェックかつ最短文字数がない場合、必須エラー
    minLength:
      props?.required === true && props.minLength == null
        ? stringFormat(MESSAGES.WARNS.W001, title)
        : stringFormat(MESSAGES.WARNS.W002, title, props?.minLength ?? 0),
    maxLength: stringFormat(MESSAGES.WARNS.W003, title, props?.maxLength ?? 0),
    pattern: stringFormat(patternMessage, title),
    enum: stringFormat(MESSAGES.WARNS.W006, title),
    type: stringFormat(patternMessage, title),
  }
}
/**
 * 必須入力に対するエラーメッセージ表示用関数
 * @param targets
 * @returns
 */
export const JsonSchemeRequiredErrorMessages = <
  T extends { [name: string]: any }
>(
  targets: ([keyof T, string] | keyof T)[]
) => {
  const returnObject: Partial<{
    [key in keyof T]: string
  }> = {}
  targets.forEach((target) => {
    if (target instanceof Array) {
      returnObject[target[0]] = stringFormat(MESSAGES.WARNS.W001, target[1])
    } else {
      returnObject[target] = stringFormat(
        MESSAGES.WARNS.W001,
        target.toString()
      )
    }
  })
  return returnObject
}
